<br>
<br>
<br>
<br>
<div class="carrier_details">
    <div class="stepper_head space_between">
      <span class="opensans-semi-bold-sapphire-30px design"
        >Annual Compliance Certificate Application</span
      >
      <!-- <button
        type="submit"
        *ngIf="complianceIds.length > 1"
        (click)="excludeConfirmation()"
        class="btn btn_primary btn_lg"
      >
        Exclude this Compliance Certificate
      </button> -->
    </div>

    <div class="detail_row">
      <div class="column" style="font-weight: bold;"><b>Permit Number:</b></div>
      <div class="column" style="font-weight: bold;"><b>{{ currentPermitDetails?.permit_num | checknull }}</b></div>
    </div>
    <div class="detail_row">
      <div class="column">Carrier name:</div>
      <div class="column">
        {{ currentPermitDetails.carrier_name }}
      </div>
    </div>
    <div class="detail_row">
      <div class="column">Permit type:</div>
      <div class="column">
        {{ currentPermitDetails.permit_type }}
      </div>
    </div>

    <div class="detail_row">
      <div class="column">Route:</div>
      <div class="column">
        {{ currentPermitDetails?.route | checknull }}
      </div>
    </div>
    <div class="detail_row">
      <div class="column">Vehicle:</div>
      <div class="column">
        {{ currentPermitDetails?.registration_number | checknull }}
      </div>
    </div>
    <div class="detail_row">
      <div class="column">CIPC Compliant:</div>
      <div class="column">
        {{ compliantStatuses?.company_status | checknull }}
      </div>
    </div>
    <div class="detail_row">
      <div class="column">SARS Compliant:</div>
      <div class="column">
        {{ compliantStatuses?.sars_status | checknull }}
      </div>
    </div>
    <div class="detail_row">
      <div class="column">eNatis Compliant:</div>
      <div class="column">
        {{ compliantStatuses?.vehicle_status | checknull }}
      </div>
    </div>
  </div>

  <br />
  <br />
  <div class="stepper_head space_between">
    <span class="opensans-semi-bold-sapphire-30px design">Documents</span>
  </div>
  <p class="para">
    Please ensure documents being submitted are clear and viable, any
    document that are not clear and viable will be rejected.
  </p>
  <p class="para">
    All foreign documents must be translated by a certified translator into
    English.
  </p>
  <br />
  <br />

  <ng-container *ngFor="let docs of permitDocumentsLink; let i = index">
    <div class="stepper_head space_between">
      <span class="opensans-semi-bold-sapphire-30px design">
        {{ i + 1 }}. {{ docs.description }}
      </span>
    </div>

    <div class="dropzone" fileDragDrop>
      <div class="file_upload_wrapper">
        <img src="/assets/upload_icon.png" alt="Upload icon" />
        <input
          type="file"
          id="upload_file"
          class="file_upload_input"
          title=""
          multiple
          accept=".pdf"
          (change)="onChangeFile($event, docs.document_type_id)"
        />
        <label for="upload_file">
          Drag and drop files here or click to search on your computer
        </label>
        <span class="upload_file_text">Upload file</span>
      </div>
    </div>
    <span class="max_limit">Max file size 5MB PDF format.</span>
    <br />
    <br />

    <ng-container *ngFor="let id of allDocs | keyvalue">
      <ng-container *ngIf="id.key == docs.document_type_id">
        <div class="uploaded_files_wrapper">
          <h2>Files Uploaded ({{ id.value.length }})</h2>
          <ul class="uploaded_files_list">
            <ng-container *ngFor="let doc of id.value">
              <li>
                <span class="name">{{ doc.fileName }}</span>
                <span class="type">PDF</span>
                <span class="file_size">{{
                  doc.date_created | date : "dd/MM/yyyy h:mm a"
                }}</span>
                <div class="actions">
                  <button
                    type="button"
                    class="btn_icon"
                    data-toggle="modal"
                    data-target="#exampleModalLong"
                    aria-label="View file"
                    (click)="
                      viewDoc(doc)
                    "
                  >
                    <img src="assets/visibility.png" alt="" />
                  </button>
                  <button
                    type="button"
                    class="btn_icon delete"
                    aria-label="Delete file"
                    (click)="onConfirm(doc)"
                  >
                    <img src="assets/delete.png" alt="" />
                  </button>

                  <div class="form-inline-checkbox">
                    <input
                      class="form-control input-sm"
                      type="checkbox"
                      id="document"
                      value="document"
                      [checked]="isChecked" 
                      (click)="
                      onUseDocumentCheckNew(
                          $event,
                          doc
                        )
                      "
                    />
                    <label for="document">Use this document</label>
                  </div>
                  

                </div>
              </li>
            </ng-container>
          </ul>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>

  <div class="row paginater-wrap" *ngIf="complianceIds.length > 1">
    <div class="col paginater" style="text-align: right">
      <button
        (click)="onPageChange(pageNumber - 1)"
        [disabled]="pageNumber == 1"
        [ngClass]="pageNumber == 1 ? 'disabled' : ''"
        class="prev"
      >
        Prev
      </button>
      <ng-container *ngFor="let page of complianceIds; let i = index">
        <span
          [ngClass]="{ active: pageNumber === i + 1 }"
          (click)="onPageChange(i + 1)"
          >{{ i + 1 }}</span
        >
      </ng-container>
      <button
        [disabled]="complianceIds.length == pageNumber"
        (click)="onPageChange(pageNumber + 1)"
        [ngClass]="complianceIds.length == pageNumber ? 'disabled' : ''"
        class="next"
      >
        Next
      </button>
    </div>
  </div>
  <br />
  <br />
  <div class="col-12 action_buttons_wrapper">
    <button
      title="Cancel"
      type="submit"
      id="btnCancel"
      class="btn hd-btn-close"
      (click)="cancel()"
    >
      Cancel
    </button>
    <button
     
      type="submit"
      (click)="onClickSubmit(2)"
      id="btnSave"
      class="btn hd-btn"
    >
      Next
    </button>

    <button
    style="display: none"
    name="checkoutFormBtn"
    id="checkoutFormBtn"
    class="button"
    type="submit"
  >
    Purchase
  </button>
  </div>
  <div class="modal fade" id="exampleModalLong" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle"
  aria-hidden="true">
 <div class="modal-dialog modal-lg" role="document">
     <div class="modal-content">
         <div class="modal-header">
             <h5 class="modal-title" id="exampleModalLongTitle">View Uploaded Doc</h5>
             <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                 <span aria-hidden="true">&times;</span>
             </button>
         </div>

         <div class="modal-body modal-lg">

             <div style="width: 99%; min-height: 470px;" >

                 <pdf-viewer *ngIf="pdfSrc" [src]="pdfSrc" [render-text]="true" style="display: block;"
                             [original-size]="false" [autoresize]="true"></pdf-viewer>
             
                 <img [src]="img" *ngIf="img">
                 <ngx-loading [show]="isLoadingImg"></ngx-loading>
             </div>


         </div>
         <div class="modal-footer">
           
             <button type="button" class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2" 
                     data-dismiss="modal">Close
             </button>
             <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
         </div>
     </div>
 </div>
